import { __extends } from "tslib";
import "azure-devops-ui/CommonImports";
import "azure-devops-ui/Core/core.css";
import "./Accordion.css";
import * as React from "react";
import { CSSTransitionGroup } from "react-transition-group";
import { getId } from "azure-devops-ui/Core/Util/Object";
import { Button } from "azure-devops-ui/Button";
import { Icon } from "azure-devops-ui/Icon";
import { Observer } from "azure-devops-ui/Observer";
import { Tooltip } from "azure-devops-ui/TooltipEx";
import { css, getSafeId } from "azure-devops-ui/Util";
var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    function Accordion(props) {
        var _this = _super.call(this, props) || this;
        _this.controlId = getId("accordion-section-group-content");
        return _this;
    }
    Accordion.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: css("bolt-accordion-section-group", this.props.className) },
            React.createElement(Observer, { sections: this.props.sections }, function (sectionProps) {
                return sectionProps.sections.map(function (s, index) { return _this.renderSection(s, index); });
            })));
    };
    Accordion.prototype.renderSection = function (section, index) {
        var _this = this;
        var itemId = this.controlId + "-" + index;
        return (React.createElement(Observer, { key: section.key, isCollapsed: section.isCollapsed }, function (props) {
            return (React.createElement("div", null,
                React.createElement("span", { className: "flex-row" },
                    React.createElement(Button, { subtle: true, onClick: function (event) {
                            section.onClick && section.onClick(event);
                            if (!event.isDefaultPrevented()) {
                                _this.props.onSectionClicked && _this.props.onSectionClicked(event, section);
                            }
                        }, className: "bolt-accordion-section-header flex-grow", ariaExpanded: !props.isCollapsed, ariaControls: !props.isCollapsed ? itemId : undefined },
                        React.createElement("span", { className: "bolt-accordion-section-header-content flex-row flex-grow" },
                            React.createElement(Tooltip, { overflowOnly: true },
                                React.createElement("div", { className: "body-m font-weight-semibold flex-grow text-ellipsis" }, section.title || section.key)),
                            React.createElement(Icon, { iconName: "ChevronDownMed", className: css("bolt-accordion-section-chevron", !props.isCollapsed && "rotate") })))),
                React.createElement(CSSTransitionGroup, { transitionName: "bolt-accordion-section-content", transitionEnter: true, transitionLeave: true, transitionEnterTimeout: 150, transitionLeaveTimeout: 150 }, !props.isCollapsed && (React.createElement("div", { id: getSafeId(itemId), className: "bolt-accordion-section-content" }, section.onRenderContent())))));
        }));
    };
    return Accordion;
}(React.Component));
export { Accordion };
